<template>
  <div id="m-configs-merge">
    <config-merge-popup
        ref="config-merge-popup"
        v-on:show-c-diff-preview-popup="showDiffPreviewPopup"
    ></config-merge-popup>
    <configs-popup-edit-info ref="configs-popup-edit-info"></configs-popup-edit-info>
    <c-edit-value-dialog ref="c-edit-value-dialog"/>
    <c-diff-preview-popup
        v-on:resolve-conflict="onResolveConflict"
        ref="c-diff-preview-popup"
    ></c-diff-preview-popup>
    <c-import-config-popup
        ref="c-import-config-popup"
    ></c-import-config-popup>
    <v-card elevation="0">
      <v-card-actions class="ma-0 pa-0">
        <c-l-table
            v-on:show-config-merge-popup="showMergeAndDeployPopup"
            v-on:show-configs-popup-edit-info="showEditInfoPopup"
            v-on:show-c-edit-name="onEditName"
            v-on:show-c-edit-marker="onEditMarker"
            v-on:show-c-import-config-popup="showImportConfigPopup"
            ref="c-l-table"
        ></c-l-table>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>

import CLTable from "@/modules/mconfigs/views/list/c-l-table";
import CDiffPreviewPopup from "@/modules/mconfigs/views/list/popups/c-diff-preview-popup";
import ConfigsPopupEditInfo from "@/modules/mconfigs/views/popups/configs-popup-edit-info";
import {ConfigStoreUtils} from "@/modules/mconfigs/database/ConfigStoreUtils";
import ConfigMergePopup from "@/modules/mconfigs/views/popups/config-merge-popup";
import CEditValueDialog from "@/modules/mconfigs/views/list/popups/c-edit-value-dialog.vue";
import CImportConfigPopup from "@/modules/mconfigs/views/list/popups/c-import-config-popup.vue";

export default {
  name: 'c-l',
  components: {
    CImportConfigPopup,
    CEditValueDialog,
    ConfigMergePopup,
    ConfigsPopupEditInfo, CDiffPreviewPopup, CLTable
  },
  methods: {
    showEditInfoPopup(config) {
      this.$refs['configs-popup-edit-info'].show(config, function (config, newInfo) {
        let copy = config.clone()
        copy.info = newInfo
        ConfigStoreUtils.updateConfig(copy)
            .then(() => {
              this.$notify({title: 'Info successfully changed!', text: "", type: "succes"});
            }).catch((error) => {
          this.$notify({title: 'Info change failed!', text: error, type: "error"});
        })
      })
    },
    showMergeAndDeployPopup(startItem) {
      this.$refs['config-merge-popup'].show(startItem)
    },

    onEditName(item) {
      this.$refs['c-edit-value-dialog'].show(item.group).then(
          result => {
            let data = item.clone();
            data.group = result;

            ConfigStoreUtils.updateConfig(data)
                .then(() => {
                  this.$notify({title: 'Data successfully changed!', text: "", type: "success"});
                }).catch((error) => {
              this.$notify({title: 'Data change failed!', text: error, type: "error"});
            })
          }, () => {
          });
    },
    onEditMarker(item) {
      this.$refs['c-edit-value-dialog'].show(item.marker).then(
          result => {
            let data = item.clone();
            data.marker = result;

            ConfigStoreUtils.updateConfig(data)
                .then(() => {
                  this.$notify({title: 'Data successfully changed!', text: "", type: "success"});
                }).catch((error) => {
              this.$notify({title: 'Data change failed!', text: error, type: "error"});
            })
          }, () => {
          });
    },

    showDiffPreviewPopup(resolved, configA, configB, dataA, dataB, item) {
      this.$refs['c-diff-preview-popup'].show(resolved, configA, configB, dataA, dataB, item)
    },
    onResolveConflict(resolved, item, stringC) {
      this.$refs['config-merge-popup'].onResolve(resolved, item, stringC);
    },
    showImportConfigPopup(config, configData) {
      this.$refs['c-import-config-popup'].show(config, configData).then(
          configData => {
            this.$notify({title: 'Import successful!', text: "", type: "success"});
            ConfigStoreUtils.pushConfig(config, configData)
                .then(() => {
                  this.$notify({title: 'Config successfully imported!', type: "success"});
                }).catch((error) => {
              this.$notify({title: 'Config duplicate failed!', text: error, type: "error"});
            })
          },
          error => {
            this.$notify({title: 'Import with error!', text: error, type: "error"});
          }
      )
    },
  }
}
</script>